<div class="container">
  <div class="close-button d-flex justify-content-end mb-3">
    <button (click)="activeModal.close()" type="button" class="btn">
      <span class="material-symbols-outlined">
        close
      </span>
    </button>
  </div>
  <p class="title">
    Input the below detail to receive an OTP to your reset password
  </p>

  @if (errorMessage) {
    <div class="error-div mb-3">
      <span>
        {{errorMessage}}
      </span>
    </div>
  }

  <form autocomplete="false" novalidate role="form" >
    <div class="form-row">
      <div >
        <div class="form-floating">
          <input autocomplete="off" type="email" [formControl]="email" placeholder="Email Address" class="form-control" type="email">
          <label>Email Address</label>
        </div>
      </div>
    </div>

    <button (click)="onForgotPassword()" type="button" class="mx-auto btn prjct-btn mt-5">
      Send OTP
    </button>
  </form>

</div>
